module.exports = __webpack_public_path__ + "img/case3-bg.3a2dd6fa.png";